module.exports = __webpack_public_path__ + "img/avatar.f4d07589.png";